import { useState, useRef, useEffect } from "react";
import Icons from "../myIcon/Icons";

const CustomSelect = ({
  name, // New prop for the field name
  options = [],
  placeholder = "Select",
  onChange = () => {},
  multiple = false,
  defaultValue = multiple ? [] : null, // Prop for default selected value
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(multiple ? [] : null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Initialize the selected state based on the defaultValue prop
    if (!Array.isArray(options)) return; 
    if (defaultValue) {
      if (multiple) {
        const defaultOptions = options.filter((option) =>
          defaultValue.includes(option._id)
        );
        setSelected(defaultOptions);
      } else {
        const defaultOption = options.find((option) => option._id === defaultValue);
        setSelected(defaultOption || null);
      }
    }
  }, [defaultValue, options, multiple]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    if (multiple) {
      const isAlreadySelected = selected.some((item) => item._id === option._id);
      const updatedSelection = isAlreadySelected
        ? selected.filter((item) => item._id !== option._id)
        : [...selected, option];

      setSelected(updatedSelection);

      const ids = updatedSelection.map((item) => item._id).join(",");
      const fakeEvent = { target: { name, value: ids } }; // Include the name if provided
      onChange(fakeEvent);
    } else {
      setSelected(option);
      setIsOpen(false);

      const fakeEvent = { target: { name, value: option._id } }; // Include the name if provided
      onChange(fakeEvent);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const isSelected = (option) => {
    if (multiple) {
      return selected.some((item) => item._id === option._id);
    }
    return selected?._id === option._id;
  };

  return (
    <div className="custom-select-wrapper form-control" ref={dropdownRef}>
      <div className="custom-select" onClick={toggleDropdown}>
        <div className="custom-select-trigger">
          {multiple
            ? selected.length > 0
              ? selected.map((item) => item.name).join(", ")
              : placeholder
            : selected?.name || selected?.title || placeholder}
        </div>
        <Icons name="arrowDown"/>
        {isOpen && (
          <div className="custom-options">
            {options.map((option) => (
              <span
                key={option._id}
                className={`custom-option ${
                  isSelected(option) ? "selected" : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.name || option.title} 
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomSelect;